/**
 * Proxied url for images, pdf, xml etc. to avoid cors errors
 * @param {string} url - Any url we want to proxy
 * keywords: proxy, cors, images
 */
const getCorsUrl = (url: string): string =>
  `${process.env.API_GATEWAY_ENDPOINT}/cors?url=${encodeURIComponent(url)}`;

export default getCorsUrl;
